import React from 'react';
import './style.css';

const Loader=({lang})=>{
  return (
    <div className="text-center text-secondary">
      <svg x="0px" y="0px" height="3px" width="100%" viewBox="0 0 100 100">
        <g fill="#999" stroke="2" y="0" x="0">
          <rect x="0" y="0" width="100%" height="100%" />
          <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="scale"
              from="0 1"
              to="100 1"
              begin="0s"
              dur="0.8s"
              repeatCount="indefinite"
            />
        </g>
        <g fill="#999" stroke="2" y="0" x="0">
          <rect x="0" y="0" width="100%" height="100%" />
          <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="scale"
              from="0 1"
              to="-100 1"
              begin="0s"
              dur="0.8s"
              repeatCount="indefinite"
            />
        </g>
      </svg>
      Estamos accediendo a tu usuario  {/* TODO: utilizar lang  */}
    </div>
  );
}

export default Loader;